import { PipeTransform, Pipe } from "@angular/core";
import momentImported from "moment";
const moment = momentImported;

@Pipe({
    name: "wafTime",
    standalone: false
})
export class TimeStringPipe implements PipeTransform {
  private static readonly ISO8601 = "YYYY-MM-DD HH:mm";

  transform(value: any, pattern?: string) {
    if (value) {
      if (typeof value === "string") {
        const valueDate = new Date(value);

        if (!this.isValidDate(valueDate)) {
          value = `1970-01-01 ${value}`;
        }
      }

      const momentObj = moment(value, TimeStringPipe.ISO8601);

      return momentObj.format(pattern || "LT");
    }

    return "";
  }

  private isValidDate(d: any): boolean {
    return d instanceof Date && !isNaN(d.getTime());
  }
}
